import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  update(text) {
    this.element.textContent = text
  }

  clear() {
    this.element.textContent = ''
  }
}
